import * as React from 'react';
export const oxxoSvg = React.forwardRef(function oxxoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 10.876a.5.5 0 0 1-.498.498H.498A.5.5 0 0 1 0 10.876v-.227h16v.227Zm-4.646-5.782c-.457.273-.81.805-1.155 1.207l-.704.82-.817-.982-.517.64.803.958-1.226 1.426c-.305.457.259.923.618.506l1.13-1.31 1.159 1.383c.353.422.923-.036.625-.497l-1.253-1.5.79-.918c.84-.973 1.419-1.762 2.65-1.733H16v5.186H4.754c.45-.284.79-.806 1.127-1.216l.684-.835.823.926.52-.615-.826-.94 1.193-1.454c.295-.463-.28-.916-.63-.49l-1.1 1.334-1.19-1.355c-.363-.414-.922.056-.613.51L6.03 7.618l-.77.936c-.817.992-1.375 1.727-2.606 1.727H0V5.094h11.354Zm-8.747.398c-1.156 0-2.1.943-2.1 2.1 0 1.156.944 2.1 2.1 2.1 1.157 0 2.1-.944 2.1-2.1 0-1.157-.943-2.1-2.1-2.1Zm10.953 0c-1.157 0-2.1.943-2.1 2.1 0 1.156.943 2.1 2.1 2.1 1.156 0 2.1-.944 2.1-2.1 0-1.157-.944-2.1-2.1-2.1Zm-10.953.77c.732 0 1.329.598 1.329 1.33A1.33 1.33 0 0 1 2.607 8.92a1.331 1.331 0 0 1-1.329-1.328c0-.732.597-1.33 1.33-1.33Zm10.953 0c.731 0 1.328.598 1.328 1.33A1.33 1.33 0 0 1 13.56 8.92c-.732 0-1.33-.597-1.33-1.328 0-.732.598-1.33 1.33-1.33ZM15.502 4a.5.5 0 0 1 .498.498v.226H0v-.226A.5.5 0 0 1 .498 4h15.004Z',
    }),
  );
});
oxxoSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var oxxo = {
  category: 'paymentmethod',
  colorable: true,
  name: 'oxxo',
  svg: oxxoSvg,
};
